import { GrowthDashboardTopBarActions, SuggestedCampaignsView } from '@elva/ui';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useSuggestedCampaignMutations, useSuggestedCampaigns } from '../hooks/useCampaigns';

export function CampaignsPage() {
  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } =
    useSuggestedCampaigns();
  const { dismiss, accept } = useSuggestedCampaignMutations();

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
      isEmpty={data !== undefined && data.gcItems.length === 0}
    >
      <SuggestedCampaignsView
        {...viewProps({
          items: data?.gcItems,
          loading: isFetching,
          onDismiss: (id: number) => {
            const backendId = data?.idMap[id];
            if (backendId) dismiss.mutate(backendId);
          },
          onLaunchAutopilot: (id: number) => {
            const backendId = data?.idMap[id];
            if (backendId) accept.mutate({ id: backendId, mode: 'autopilot' });
          },
          onLaunchReview: (id: number) => {
            const backendId = data?.idMap[id];
            if (backendId) accept.mutate({ id: backendId, mode: 'review' });
          },
        })}
      />
    </AsyncBoundary>
  );
}
